define([
    "knockout"
], function(ko) {
    "use strict";

    return ko.observable();
});
